import BaseService from '@/services/BaseService'

class OrderService {

    constructor() {
        this._httpService = new BaseService();
    }

    getPersonOrders() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/orders`,
            method: 'GET'
        }
        console.info('personOrders')
        return this._httpService.service(settings)
    }

    getPersonOrderDetail(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/orders/${orderId}`,
            method: 'GET'
        }
        console.info('personOrderDetail')
        return this._httpService.service(settings)
    }

    getOrderDocument(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/order-doc/${orderId}`,
            method: 'GET',
            responseType: 'blob'
        }
        console.info('getOrderDocument')
        return this._httpService.service(settings)
    }

    postOptimization(board) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/optimization`,
            method: 'POST',
            data: board
        }
        return this._httpService.service(settings)
    }

    postCuttingOrder(board) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/orders`,
            method: 'POST',
            data: board
        }
        return this._httpService.service(settings)
    }

    cancelOrder(orderId) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/customer-management/orders/${orderId}/cancel`,
            method: 'PUT'
        }
        return this._httpService.service(settings)
    }
}

export default OrderService